module.exports = __webpack_public_path__ + "img/ИФ-1(А)-041-m.1e683858.png";